import apiClient from './client';

export interface IntegrationStatus {
  oauthConfigured: boolean;
  authorized: boolean;
  mapsConfigured: boolean;
  driveBackupConfigured: boolean;
  calendarId: string;
}

export interface DriveFile {
  id: string;
  name: string;
  mimeType: string;
  modifiedTime?: string;
  size?: string;
}

export const getIntegrationStatus = async (): Promise<IntegrationStatus> => {
  const { data } = await apiClient.get('/integrations/google/status');
  return data.data;
};

export const getGoogleAuthUrl = async (): Promise<string> => {
  const { data } = await apiClient.get('/integrations/google/oauth/url');
  return data.url;
};

export const disconnectGoogle = async (): Promise<void> => {
  await apiClient.post('/integrations/google/oauth/disconnect');
};

export interface MapEmbed {
  configured: boolean;
  embedUrl?: string;
}

export const getMapEmbed = async (address: string): Promise<MapEmbed> => {
  const { data } = await apiClient.get('/integrations/maps/embed', { params: { address } });
  return data.data;
};

export const syncJobToCalendar = async (jobId: number | string) => {
  const { data } = await apiClient.post(`/integrations/calendar/sync/job/${jobId}`);
  return data;
};

export const syncScheduleToCalendar = async (scheduleId: number | string) => {
  const { data } = await apiClient.post(`/integrations/calendar/sync/schedule/${scheduleId}`);
  return data;
};

export const listDriveFiles = async (folderId?: string): Promise<DriveFile[]> => {
  const { data } = await apiClient.get('/integrations/drive/files', { params: { folderId } });
  return data.data;
};

export const uploadToDrive = async (file: File, folderId?: string): Promise<DriveFile> => {
  const form = new FormData();
  form.append('file', file);
  if (folderId) form.append('folderId', folderId);
  const { data } = await apiClient.post('/integrations/drive/upload', form);
  return data.data;
};

export const downloadDriveFile = async (file: DriveFile): Promise<void> => {
  const res = await apiClient.get(`/integrations/drive/download/${file.id}`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(res.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const backupDatabaseNow = async () => {
  const { data } = await apiClient.post('/integrations/drive/backup');
  return data;
};
